export const modernProductsGrid = [
  {
    id: 1,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/1.webp`,
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [6, 7, 8, 9, 10, 11],
  },
  {
    id: 2,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/2.webp`,
    title: 'Beats Headphone',
    description: 'High Quality Wireless Headphone',
    price: 315.0,
    sale_price: 499.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [9, 8, 11, 6, 7, 10],
  },
  {
    id: 3,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/3.webp`,
    title: 'Marc Jacob’s Decadent',
    description: 'Classic Marc Jacob’s Fragrance',
    price: 99.0,
    sale_price: 100.99,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [7, 11, 6, 9, 8, 10],
  },
  {
    id: 4,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp`,
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 77.0,
    sale_price: 95.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [10, 6, 8, 9, 7, 11],
  },
  {
    id: 5,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp`,
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 45.0,
    sale_price: 55.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [6, 9, 7, 10, 11, 8],
  },
  {
    id: 6,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp`,
    title: 'Nike Shoe',
    description: 'High Quality Wireless Headphone',
    price: 119.0,
    sale_price: 149.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [11, 10, 9, 8, 7, 6],
  },
  {
    id: 7,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp`,
    title: 'Denim Jacket',
    description: 'Classic Marc Jacob’s Fragrance',
    price: 79.0,
    sale_price: 99.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [8, 9, 7, 11, 6, 10],
  },
  {
    id: 8,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/8.webp`,
    title: 'Ladies High Hill',
    description: 'Classic Black Heels For Women',
    price: 49.99,
    sale_price: 109.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [7, 6, 11, 10, 8, 9],
  },
  {
    id: 9,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/9.webp`,
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [9, 11, 6, 7, 8, 10],
  },
  {
    id: 10,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/10.webp`,
    title: 'Beats Headphone',
    description: 'High Quality Wireless Headphone',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [10, 8, 9, 7, 11, 6],
  },
  {
    id: 11,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/11.webp`,
    title: 'Marc Jacob’s Decadent',
    description: 'Classic Marc Jacob’s Fragrance',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [6, 7, 11, 8, 10, 9],
  },
  {
    id: 12,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/12.webp`,
    title: 'Apple AirPods',
    description: 'Mobile Accessories | Wireless Earphone',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [11, 9, 10, 8, 7, 6],
  },
  {
    id: 13,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/13.webp`,
    title: 'Soap Bars',
    description: 'Saffron Handmade Bar',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [8, 7, 6, 10, 11, 9],
  },
  {
    id: 14,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/14.webp`,
    title: 'Beats Headphone',
    description: 'High Quality Wireless Headphone',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [10, 6, 9, 8, 7, 11],
  },
  {
    id: 15,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/15.webp`,
    title: 'Clutch Bag',
    description: 'Ladies Bag 12x112',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [7, 11, 10, 9, 8, 6],
  },
  {
    id: 16,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/16.webp`,
    title: 'Versace Eros',
    description: 'Perfume For Men',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
    sizes: [9, 8, 7, 11, 10, 6],
  },
];

export const recommendationProducts = [
  {
    id: 1,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/3.webp`,
    title: 'Marc Jacob’s Decadent',
    description: 'Classic Marc Jacob’s Fragrance',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 2,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp`,
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 3,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp`,
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 4,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp`,
    title: 'Marc Jacob’s Decadent',
    description: 'Classic Marc Jacob’s Fragrance',
    price: 295.0,
    sale_price: 320.0,
    colors: [],
  },
  {
    id: 5,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/8.webp`,
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 6,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/3.webp`,
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 7,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp`,
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 8,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp`,
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
];

export const recentlyProducts = [
  {
    id: 1,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/1.webp`,
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 2,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/2.webp`,
    title: 'Beats Headphone',
    description: 'High Quality Wireless Headphone',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 3,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/3.webp`,
    title: 'Marc Jacob’s Decadent',
    description: 'Classic Marc Jacob’s Fragrance',
    price: 295.0,
    sale_price: 320.0,
    colors: [],
  },
  {
    id: 4,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp`,
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 5,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp`,
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 6,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp`,
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 7,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/2.webp`,
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
];

// minimal products data
export const minimalProducts = [
  {
    id: 1,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/1.webp`,
    title: 'Casio Watch',
    description: 'Casio Classic Watch',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 2,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/2.webp`,
    title: 'Beats Headphone',
    description: 'High Quality Wireless Headphone',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
  {
    id: 3,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/3.webp`,
    title: 'Marc Jacob’s Decadent',
    description: 'Classic Marc Jacob’s Fragrance',
    price: 295.0,
    sale_price: 320.0,
    colors: [],
  },
  {
    id: 4,
    thumbnail: `https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp`,
    title: 'Black Shoes',
    description: 'Classic Black Heels For Women',
    price: 295.0,
    sale_price: 320.0,
    colors: [
      { name: 'Breaker Bay', code: '#6AA39C' },
      { name: 'Malibu', code: '#6BDCFF' },
      { name: 'Purple Heart', code: '#5D30DD' },
      { name: 'Alizarin Crimson', code: '#D72222' },
      { name: 'Viola', code: '#C886A9' },
    ],
  },
];
